// ──────────────────────────────────────────────────────────────
// Events for the Central Counter MFE
// ──────────────────────────────────────────────────────────────

export const CENTRAL_EVENTS = {
  // ── Warroom → MFE (inbound) ──────────────────────────────────
  SHOW: 'mfe-central-counter-show',
  HIDE: 'mfe-central-counter-hide',
  REFRESH: 'mfe-central-counter-refresh',

  // ── MFE → Warroom (outbound) ─────────────────────────────────
  LOADING: 'mfe-central-counter-loading',
  LOADED: 'mfe-central-counter-loaded',
  ERROR_LOADING: 'mfe-central-counter-error-loading',
  VISIBILITY_CHANGE: 'mfe-central-counter-visibility-change',
} as const;

export type CentralEventName =
  (typeof CENTRAL_EVENTS)[keyof typeof CENTRAL_EVENTS];
